import { useMemo } from 'react'
import { useAuthContext } from '../../AuthContext.js'
import { useAuthProvider } from '@maui-mf/root'

export function useUserinfo() {
  const { userinfo } = useAuthProvider()
  return useMemo(() => userinfo || {}, [userinfo])
}

export function useUserinfoAppUrls() {
  const { app_hosts: hosts } = useUserinfo()

  return useMemo(() => {
    if (!hosts) {
      return {}
    }

    return hosts.reduce((urls, item) => ({
      ...urls,
      [item.software_type]: {
        host: item.url,
      }
    }), [])
  }, [hosts])
}

export function useUserinfoAppHost(softwareType) {
  const urls = useUserinfoAppUrls()

  return useMemo(() => {
    return urls && urls[softwareType]?.host
  }, [softwareType, urls])
}

export function usePOVEndDate() {
  const { userinfo, hasPOV } = useAuthContext()

  // Matching POV object
  const pov = useMemo(() => {
    if (!hasPOV) return
    if (!userinfo?.entitlement_info) {
      return {}
    }
    return userinfo.entitlement_info.find(info => info.id.includes('_POV'))
  }, [hasPOV, userinfo])

  return pov
}
